import React, { Component } from "react";
import { graphql, Link } from "gatsby";
import SEO from "../components/seo";
import Layout from "../components/layout";
import ServiceHero from "../components/service-hero";
import CTA from "../components/cta-bar";
import styled from "styled-components";
import Card from "../components/card";
import PhotoGalleryComponent from "../components/photo-gallery-component";
import SocialReviewsFullwidth from "../components/social-reviews-fullwidth";
import { TestimonialSection } from "../components/testimonial_video";
import {
  TOWN_PAGE_CATALOGS,
  cityPlace,
  officeNodeForCity,
  providerIdForCity,
  serviceNode,
} from "../helpers/schema";
import FAQ from "../components/FAQ";
import RoofingCalculator from "../components/sidebars/roof-calc";
import WhyRoachStandsOut from "../components/why-roach-stands-out";
import RoofingServicesGrid, { serviceCards } from "../components/roofing-services-grid";
import GetANewRoofSteps from "../components/get-a-new-roof-steps";
import JacksonEmergencyAndCosts from "../components/jackson-emergency-and-costs";
import CityTrustStrip from "../components/city-trust-strip";
import CityHappyCustomers from "../components/city-happy-customers";
import CityTrustedChoice from "../components/city-trusted-choice";
import CityNeighborhoods from "../components/city-neighborhoods";
import CityContactCard from "../components/city-contact-card";
import WyomingCostsAndPermits from "../components/wyoming-costs-and-permits";
import CityCtaPair from "../components/city-cta-pair";
import CityEmergencyRepair from "../components/city-emergency-repair";
import CityBodyContent from "../components/city-body-content";
import CityOtherServices from "../components/city-other-services";
import siteConfig from "../siteConfig";
import cityPageContent from "../data/city-page-content";

// The review page the review-site buttons (Yelp, Google, ...) open, by service.
// Contentful sets one review page per service entry, shared by every town, and
// all five entries point at windows-doors, so ~60 roofing pages linked roofing
// readers to the window and door reviews. Siding has no reviews of its own yet,
// so its pages open the full list.
const REVIEWS_PAGE_FOR_SERVICE = {
  roofing: "roofing",
  "roofing-repair": "roofing",
  "siding-contractor": "all",
  "window-replacement-contractor": "windows-doors",
  "exterior-door-installers": "windows-doors",
};

const MainContentContainer = styled.div``;
const SidebarContainer = styled.div``;

const WhiteBGSection = styled.section`
  background: #f9f9f9;
  padding: 2.5em 1em;
  box-shadow: rgba(0, 0, 0, 0.03) 0px 2px 4px 0px;
`;
class ServiceCityTemplate extends Component {
  render() {
    function parseContent(string, altCity) {
      if (string) {
        const newString = string.replace(/{{city}}/g, altCity ? altCity : city);
        const secondReplacement = newString.replace(
          /{{citySlug}}/g,
          (altCity ? altCity : city).replace(/\./g, "").toLowerCase().replace(/\s/g, "-") + "-mi"
        );

        return secondReplacement;
      }
    }
    let { pageContext } = this.props;
    const city = pageContext.city;
    let pageData = this.props.data.contentfulServiceAreaContent;
    let citiesList = this.props.data.allContentfulServiceArea.edges;
    let content = parseContent(pageData.content.content);
    let zipCodes = pageContext.zipCodes;

    //replace city in keywords array
    if (pageData.metaKeywordsList) {
      pageData.metaKeywordsList.forEach(function (keyword, index) {
        pageData.metaKeywordsList[index] = parseContent(keyword);
      });
    }

    const TopBar = () => {
      //pageData has the data
      const topBar = pageData.topbar || [];
      return topBar.map(({ id, title, cssClasses, content }) => (
        <section key={id} className={cssClasses} dangerouslySetInnerHTML={{ __html: content.content }} />
      ));
    };
    const { testimonials: testimonial_video_posts } = pageData.testimonialSection || { testimonials: [] };

    const SidebarColumn = () => {
      const sideBarCards = pageData.sidebar.map((sidebar, index) => {
        if (sidebar.__typename == "ContentfulSidebar") {
          return <Card key={index} sidebar={sidebar} />;
        } else if (sidebar.__typename == "ContentfulSidebarCollection") {
          const innerCards = sidebar.sidebars.map((sidebar, index) => {
            return <Card key={"inner" + index} sidebar={sidebar} />;
          });
          return innerCards;
        } else return null;
      });

      return sideBarCards;
    };
    // Contentful city names carry stray leading/trailing whitespace, so always
    // use the trimmed value in URLs and copy.
    const cityName = String(city).trim();
    const cityKey = cityName.toLowerCase();
    // "roofing", "siding-contractor", "window-replacement-contractor", ...
    const serviceSlug = pageData.slug;
    // Copy overrides for this one page (city + service). The shared Contentful
    // entry for each service renders once for every city, so city-specific copy
    // has to come from code.
    const cityContent = cityPageContent.forPage(city, serviceSlug);
    // Repeated estimate/call pair, for pages whose design calls for it.
    const ctaPair = cityContent.heroTitle ? (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <CityCtaPair city={city} />
      </div>
    ) : null;
    // Jackson and Wyoming have a page design of their own (Figma 414:47 and
    // 428:38), and every section of it is roofing copy, so only their roofing
    // pages use it. Their siding, window and door pages get the standard layout
    // and their own Contentful service copy, like every other city's. Keyed on
    // the city alone, all four pages were near-identical copies of the roofing
    // page under a roofing H1.
    const featuredCity =
      serviceSlug === "roofing" && (cityKey === "jackson" || cityKey === "wyoming") ? cityKey : null;
    // Phone for the office that serves this city. Jackson and Wyoming have
    // their own lines; every other city answers on the main Battle Creek number.
    const cityOffice = siteConfig.officeForCity(city);
    // The title and description use the trimmed town name: some Contentful
    // town names carry a stray space (" Wyoming", "Holland "), and the window
    // and door patterns put ", MI" straight after the name ("Holland , MI").
    const seoTitle = parseContent(pageData.seoTitle, cityName);
    // The shared Contentful meta description hardcodes the main Battle Creek
    // line, which is the wrong number for a city with its own office.
    const metaDescription = (parseContent(pageData.metaDescription, cityName) || "").replace(
      siteConfig.phone,
      siteConfig.phoneForCity(city)
    );
    // JSON-LD (src/helpers/schema.js). Towns with a branch office (Jackson,
    // Wyoming) get that office's own business node, with its own @id, address
    // and phone, so the one sitewide entity never asserts three numbers. The
    // Service lists what this page lists: roofing town pages the service cards
    // they render, the others the services their Contentful copy names.
    const catalog = TOWN_PAGE_CATALOGS[serviceSlug] || {
      name: "Roofing Services",
      services: serviceCards(city, serviceSlug).map(({ title }) => title),
    };
    const schema = [
      officeNodeForCity(cityName),
      serviceNode({
        pathname: this.props.location.pathname,
        serviceType: pageContext.serviceTitle,
        providerId: providerIdForCity(cityName),
        areaServed: cityPlace(cityName),
        catalogName: catalog.name,
        services: catalog.services,
      }),
    ];
    return (
      <>
        <Layout pageProps={this.props} footerLogoShowcase={pageData.footerLogoShowcase} schema={schema}>
          <SEO
            title={seoTitle}
            description={metaDescription}
            keywords={pageData.metaKeywordsList ? pageData.metaKeywordsList : []}
          />
          <ServiceHero
            pageData={pageData}
            serviceTitle={cityContent.heroTitle || parseContent(pageData.serviceTitle)}
            heroImage={pageData.heroImage}
            excerpt={cityContent.heroExcerpt || parseContent(pageData.excerpt)}
            pageProps={this.props}
            badges={pageData.headerFeaturedBadges}
            specialOffer={parseContent(pageData.specialOffer)}
            offerDisclaimer={parseContent(pageData.offerDisclaimer)}
            ctaSlot={cityContent.heroTitle ? <CityCtaPair city={city} className="mt-6" /> : null}
          />
          {featuredCity ? (
            <>
              <CityTrustStrip city={city} service={serviceSlug} />
              {/* The design runs TrustedChoice before the reviews strip; cities
                  without their own copy keep the original order. */}
              {cityContent.heroTitle ? (
                <>
                  <CityTrustedChoice city={city} service={serviceSlug} />
                  <CityHappyCustomers />
                </>
              ) : (
                <>
                  <CityHappyCustomers />
                  <CityTrustedChoice city={city} service={serviceSlug} />
                </>
              )}
            </>
          ) : null}
          {pageData.socialReviewsFullWidth && pageData.socialReviewsFullWidth.slug ? (
            <SocialReviewsFullwidth
              modalLinkTo={`/reviews/${REVIEWS_PAGE_FOR_SERVICE[serviceSlug] || pageData.socialReviewsFullWidth.slug}/`}
            />
          ) : null}

          {pageData.photoGalleryRef && pageData.photoGalleryRef.photos ? (
            <PhotoGalleryComponent
              gallery={pageData.photoGalleryRef}
              titleOverride={cityContent.galleryHeading}
            />
          ) : null}

          {<TopBar />}

          {/* <TestimonialSection testimonial_video_posts={testimonial_video_posts} /> */}
          {/* bg-brand-600 text-white */}
          <div>
            <div className="flex flex-wrap  px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-8 md:py-12">
              <div className={`${pageData.sidebar ? "md:w-2/3 md:pr-4" : "w-full"} prose md:prose-lg`}>
                {/* Pages with their own copy render it from code; everyone else
                    keeps the shared Contentful body. */}
                {cityContent.bodyHeading ? (
                  <CityBodyContent city={city} service={serviceSlug} />
                ) : (
                  content && <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
                {serviceSlug === "roofing" ? <CityOtherServices city={city} cities={citiesList} /> : null}
              </div>

              {pageData.sidebar ? (
                <div className="w-full md:w-1/3 md:pl-4 space-y-4 md:space-y-6">
                  {/* <Card /> */}
                  {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49843.94525730492!2d-121.17892723112209!3d38.66620084666653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ae11b89d97a7f%3A0xd44e4c2e31e1ce2a!2sFolsom%2C%20CA!5e0!3m2!1sen!2sus!4v1625607326120!5m2!1sen!2sus" width="1200" height="500" style="border:0; max-width:100%; max-height:500px;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> */}
                  <div className="aspect-ratio-box mb-4 rounded-lg shadow-md">
                    {/* Cities we have an office in show a map pinned to that office
                        (siteConfig.offices[].mapEmbedSrc); everyone else gets a
                        generic map centred on the city. */}
                    <iframe
                      className="aspect-ratio-box-inside projects-project"
                      title={
                        cityOffice
                          ? `Map of the Roach Home Improvement office in ${cityOffice.city}, ${cityOffice.state}`
                          : `Map of ${cityName}, MI`
                      }
                      src={
                        cityOffice && cityOffice.mapEmbedSrc
                          ? cityOffice.mapEmbedSrc
                          : `https://www.google.com/maps/embed/v1/place?key=AIzaSyCwXnoLHPbHNOjKkwCoFY8u4RHtqDGp8dM&q=${encodeURIComponent(
                              `${cityName}, MI`
                            )}`
                      }
                      width="100%"
                      frameBorder={0}
                      height="400"
                      loading="lazy"
                    />
                  </div>
                  <SidebarColumn />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          {!featuredCity ? (
            <div className="rounded-2xl overflow-hidden max-w-7xl mx-auto relative px-8 py-20">
              <RoofingCalculator />
            </div>
          ) : null}
          {!featuredCity ? <WhyRoachStandsOut city={city} /> : null}
          <RoofingServicesGrid city={city} service={serviceSlug} />

          {/* Emergency section. Wyoming's is new code; Jackson already had one,
              and its copy already matches the design. */}
          <CityEmergencyRepair city={city} service={serviceSlug} />
          {featuredCity === "jackson" ? <JacksonEmergencyAndCosts city={city} section="emergency" /> : null}

          {ctaPair}

          {/* The two frames order the middle differently: Wyoming runs costs
              before "Get A New Roof In 3 Steps" and permits after; Jackson is
              the reverse, with the calculator and costs trailing. */}
          {featuredCity === "wyoming" ? <WyomingCostsAndPermits city={city} section="costs" /> : null}
          {featuredCity === "jackson" ? <JacksonEmergencyAndCosts city={city} section="permits" /> : null}

          <GetANewRoofSteps city={city} />

          {featuredCity === "wyoming" ? <WyomingCostsAndPermits city={city} section="permits" /> : null}
          {featuredCity === "jackson" ? (
            <>
              <JacksonEmergencyAndCosts city={city} section="calculator" />
              <JacksonEmergencyAndCosts city={city} section="costs" />
            </>
          ) : null}

          {/* No estimate/call pair here: both featured cities close this stretch
              with a CTA of their own (Wyoming's roof calculator "Get Pricing",
              Jackson's "Schedule a Free Consultation"), so a second one stacked
              underneath just reads as a duplicate. */}
          {featuredCity ? (
            <>
              <CityNeighborhoods
              city={city}
              cities={citiesList}
              serviceSlug={pageData.slug}
              serviceName={parseContent(pageData.serviceName) || undefined}
            />
              <CityContactCard city={city} service={serviceSlug} />
            </>
          ) : null}
          {!featuredCity ? (
            <CityNeighborhoods
              city={city}
              cities={citiesList}
              serviceSlug={pageData.slug}
              serviceName={parseContent(pageData.serviceName) || undefined}
            />
          ) : null}
          <FAQ classnames={'-mb-12'} city={city} service={serviceSlug}/>
          <CTA
            title={"Start Your " + parseContent(pageData.serviceTitle) + " Project Today!"}
            customTitle={parseContent(pageData.footerCallToActionHeading)}
            customDesc={parseContent(pageData.footerCallToActionDesc)}
            bgimage={pageData.footerCallToActionImg}
            serviceHeroImage={pageData.heroImage}
            btn={"Get Started!"}
            props={this.props}
          />
        </Layout>
      </>
    );
  }
}

export default ServiceCityTemplate;

export const pageQuery = graphql`
  query serviceCityQuery($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
        companyInfo {
          phone
          email
        }
        social {
          guildquality
          facebook
          yelp
          instagram
          google
          houzz
        }
      }
    }
    contentfulServiceAreaContent(slug: { eq: $slug }) {
      id
      serviceTitle
      serviceName
      seoTitle
      metaDescription
      slug
      excerpt
      specialOffer
      offerDisclaimer
      metaKeywordsList

      socialReviewsFullWidth {
        slug
      }
      testimonialSection {
        testimonials {
          id
          title

          video {
            id
            title
            file {
              url
              contentType
            }
          }
          thumbnail {
            gatsbyImageData(width: 600, quality: 90, placeholder: NONE)
          }
        }
      }
      photoGalleryRef {
        id
        title
        description {
          description
        }
        photos {
          id
          title
          gatsbyImageData(width: 150, quality: 70, aspectRatio: 1.26153846154, placeholder: NONE)
          fullSize: gatsbyImageData(width: 1874, quality: 70, placeholder: NONE)
        }
      }
      headerFeaturedBadges {
        title
        gatsbyImageData(width: 300, placeholder: NONE)
      }
      heroImage {
        description
        gatsbyImageData(width: 1200, quality: 70, placeholder: BLURRED)
      }
      content {
        content
      }
      footerLogoShowcase
      footerCallToActionHeading
      footerCallToActionDesc
      footerCallToActionImg {
        description
        gatsbyImageData(width: 1800, placeholder: NONE)
      }
      topbar {
        id
        title
        content {
          id
          content
        }
        cssClasses
      }
      sidebar {
        __typename
        ... on ContentfulSidebar {
          id
          title
          content {
            id
            content
          }
          testimonialCategory {
            id
            name
          }
          cssClasses
        }
        ... on ContentfulSidebarCollection {
          sidebars {
            id
            title
            content {
              id
              content
            }
            testimonialCategory {
              id
              name
            }
            cssClasses
          }
        }
      }
      schemaItemOffered
    }
    allContentfulServiceArea(filter: { slug: { ne: "warren-city-mi" } }, sort: { fields: location }) {
      edges {
        node {
          location
          slug
          marketSegment
          zipCodes
        }
      }
    }
  }
`;
